/**
 * 门禁类型枚举和选项
 */

/**
 * 门禁类型选项接口
 */
export interface AccessCodeTypeOption {
    label: string;
    value: string;
}

/**
 * 门禁类型选项列表
 * 排序规则：Gate（社区门禁）> MainDoor（楼门门禁）> SideDoor（侧门门禁）> Elevate（电梯门禁）> Garage（车库门禁）> ParcelStop（快递柜）
 * value: 无空格，用于后端存储（固定值）
 * label: 无空格，用于匹配国际化文本的 key（显示时使用 label 作为 key 获取国际化文本）
 */
export const ACCESS_CODE_TYPES: AccessCodeTypeOption[] = [
    { label: 'Gate', value: 'Gate' },
    { label: 'MainDoor', value: 'MainDoor' },
    { label: 'SideDoor', value: 'SideDoor' },
    { label: 'Elevate', value: 'Elevate' },
    { label: 'Garage', value: 'Garage' },
    { label: 'ParcelStop', value: 'ParcelStop' }
];

